import React, { useEffect, useState } from "react";
import { Button, Modal, Select } from "@opendate-app/setlist";

const VenueSelectionModal = ({
  isOpen,
  onClose,
  onConfirm,
  venueOwnerships,
  currentVenueOwnershipId,
  title = "Select a Venue",
  subtitle = "Choose a venue to associate with this item",
}) => {
  const [selectedId, setSelectedId] = useState(null);

  const venueOptions = (venueOwnerships || []).map((vo) => ({
    value: vo.id,
    label: vo.venueable?.name || vo.name || `Venue ${vo.id}`,
  }));

  useEffect(() => {
    if (!isOpen) {
      setSelectedId(null);
      return;
    }
    const current = venueOptions.find((vo) => String(vo.value) === String(currentVenueOwnershipId));
    setSelectedId(current ? current.value : null);
  }, [isOpen, currentVenueOwnershipId]);

  const handleClose = () => {
    setSelectedId(null);
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      size="sm"
      title={title}
      description={subtitle}
      footer={(
        <>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" disabled={selectedId == null} onClick={() => onConfirm(selectedId)}>Save</Button>
        </>
      )}
    >
      <Select
        label="Venue"
        options={venueOptions}
        value={selectedId}
        onChange={setSelectedId}
        placeholder="Select a venue..."
      />
    </Modal>
  );
};

export default VenueSelectionModal;
